module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer full"
  }, [_c('section', {
    staticClass: "flexContainer fd-c full t-fd-r t-fw-nw",
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('section', {
    staticClass: "planosWrapper flexContainer jc-sb mobileNot"
  }, [_c('section', {
    staticClass: "searchResultsWrapper size3of4 flexContainer fd-c tabletNot"
  }, [_c('section', [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [(_vm.hasAccessCreate('campaign_manager')) ? _c('router-link', {
    staticClass: "btnExp iBlock pointer mobileNot txtCenter active fright",
    attrs: {
      "to": "/campaigns/create",
      "tag": "span",
      "exact": ""
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("headerAdmin.campaign")) + "\n                            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "full mt10 separator"
  }), _vm._v(" "), _c('transition-group', {
    staticClass: "resultsWrapper flexContainer fw-w ",
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.campaigns), function(campaign) {
    return (campaign.active !== false) ? _c('div', {
      key: campaign.name,
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs"
    }, [_c('div', {
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs list"
    }, [_c('div', {
      staticClass: "listDisplay full ai-c jc-sb flexContainer"
    }, [_c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [_c('span', {
      staticClass: "listTitle center txtCenter"
    }, [_vm._v(_vm._s(campaign.name))])]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [(campaign.createdBy.hasOwnProperty('firstname')) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm.$t("campaignList.createdBy")) + "\n                                            " + _vm._s(campaign.createdBy.firstname) + " " + _vm._s(campaign.createdBy.lastname) + "\n                                            " + _vm._s(_vm.$t("campaignList.createdOn")) + " " + _vm._s(campaign.createdAt) + "\n                                        ")]) : _vm._e(), _vm._v(" "), (campaign.modifiedBy.hasOwnProperty('firstname')) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm.$t("campaignList.modifiedBy")) + "\n                                            " + _vm._s(campaign.modifiedBy.firstname) + " " + _vm._s(campaign.createdBy.lastname) + "\n                                            " + _vm._s(_vm.$t("campaignList.modifiedOn")) + " " + _vm._s(campaign.modifiedDate) + "\n                                        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [(campaign.launchDate !== null) ? _c('span', {
      staticClass: "center"
    }, [_vm._v(_vm._s(campaign.launchDate))]) : _c('span', {
      staticClass: "center"
    }, [_vm._v("NO LAUNCH DATE")])]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [(campaign.endDate !== null) ? _c('span', {
      staticClass: "center"
    }, [_vm._v(_vm._s(campaign.endDate))]) : _c('span', {
      staticClass: "center"
    }, [_vm._v("NO END DATE")])]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size1of5"
    }, [_c('button', {
      staticClass: "btn editBtn abs center",
      on: {
        "click": function($event) {
          _vm.editCampaign(campaign)
        }
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm.$t("editCampaign.edit")) + "\n                                        ")])])])])]) : _vm._e()
  }))], 1)])]), _vm._v(" "), (_vm.showEditCampaign) ? _c('EditCampaign', {
    on: {
      "hideEditCampaign": function($event) {
        _vm.modalClose($event)
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06cdfa5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/CampaignList.vue
// module id = 2990
// module chunks = 0